import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../app/store';
import { HourCard } from 'types/data/hourCard.t';

interface OngoingHourCardsState {
  ongoingHourCard: HourCard | null;
  isLoading: boolean;
  isLoaded: boolean;
}

const initialState: OngoingHourCardsState = {
  ongoingHourCard: null,
  isLoading: false,
  isLoaded: false
};

const ongoingHourCardsSlice = createSlice({
  name: 'ongoingHourCards',
  initialState,
  reducers: {
    setOngoingHourCardLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    markOngoingHourCardLoaded: state => {
      state.isLoading = false;
      state.isLoaded = true;
    },
    setOngoingHourCard: (state, action: PayloadAction<HourCard | null>) => {
      state.ongoingHourCard = action.payload;
      state.isLoading = false;
      state.isLoaded = true;
    },
    clearOngoingHourCard: state => {
      state.ongoingHourCard = null;
      state.isLoading = false;
      state.isLoaded = true;
    },
    resetOngoingHourCardState: () => initialState
  }
});

export const {
  setOngoingHourCardLoading,
  markOngoingHourCardLoaded,
  setOngoingHourCard,
  clearOngoingHourCard,
  resetOngoingHourCardState
} = ongoingHourCardsSlice.actions;

export const selectOngoingHourCard = (state: RootState) => state.ongoingHourCards.ongoingHourCard;

export const selectOngoingHourCardLoading = (state: RootState) => state.ongoingHourCards.isLoading;

export const selectOngoingHourCardLoaded = (state: RootState) => state.ongoingHourCards.isLoaded;

export default ongoingHourCardsSlice.reducer;
